import { render, staticRenderFns } from "./RegisterTemplateSRP.vue?vue&type=template&id=f5a15360&scoped=true&"
import script from "./RegisterTemplateSRP.vue?vue&type=script&lang=js&"
export * from "./RegisterTemplateSRP.vue?vue&type=script&lang=js&"
import style0 from "./RegisterTemplateSRP.vue?vue&type=style&index=0&id=f5a15360&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5a15360",
  null
  
)

export default component.exports